import { render, staticRenderFns } from "./JoinSearchResults.vue?vue&type=template&id=6851eba8&"
import script from "./JoinSearchResults.vue?vue&type=script&lang=ts&"
export * from "./JoinSearchResults.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports